export const minDate = new Date(2023, 8, 1);

export const minDateWeek = new Date(2023, 8, 3);
